import { Spinner } from "@twilio-paste/core/spinner";

export const Loading = () => {
    return <Spinner title="Loading" decorative={false} size="sizeIcon100" color="colorTextLink" />;
};
